import { Outlet, Link } from "react-router-dom";
import '../App.css';
const Layout = () => {
    return (
        <div className="App-body">
            <div className="App-header">
                [Beta Builder]
            </div>
            <Outlet />
        </div>
    )
};

export default Layout;